import useStyles from 'isomorphic-style-loader/useStyles';
import type { PropsWithChildren } from 'react';
import type { SemanticICONS } from 'semantic-ui-react';
import { Icon, Message } from 'semantic-ui-react';

import s from './warning-message.scss';

export interface WarningMessageProps extends PropsWithChildren {
  /**
   * Visual severity level that controls the icon and color scheme.
   *
   * - `"critical"` — red error styling (destructive actions)
   * - `"warning"` — yellow warning styling (cautionary actions)
   *
   * @default 'warning'
   */
  level?: 'critical' | 'warning';
}

const levelIcons: Record<
  NonNullable<WarningMessageProps['level']>,
  SemanticICONS
> = {
  critical: 'exclamation triangle',
  warning: 'exclamation',
};

/**
 * An icon-bearing callout message used inside modals and forms to highlight
 * important consequences of an action.
 */
export const WarningMessage = ({
  children,
  level = 'warning',
}: WarningMessageProps) => {
  useStyles(s);

  return (
    <Message
      className={s[level]}
      error={level === 'critical'}
      warning={level === 'warning'}
      icon
    >
      <Icon name={levelIcons[level]} circular />
      {children}
    </Message>
  );
};

export default WarningMessage;
